package com.ragnorak.clanybackoffice.ui.screens

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.clany.backoffice.domain.usecase.GetInvitationsUseCase
import com.clany.backoffice.model.InvitationResponse
import dev.zacsweers.metro.Inject
import kotlinx.coroutines.launch

data class InvitationsUiState(
    val isLoading: Boolean = false,
    val invitations: List<InvitationResponse> = emptyList(),
    val error: String? = null,
    val page: Int = 1,
    val hasMore: Boolean = true,
    val searchQuery: String = ""
)

class InvitationsViewModel @Inject constructor(
    private val getInvitationsUseCase: GetInvitationsUseCase
) : ViewModel() {

    var uiState by mutableStateOf(InvitationsUiState())
        private set

    init {
        loadInvitations()
    }

    fun loadInvitations(page: Int = 1) {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true, error = null)
            getInvitationsUseCase(
                page = page,
                pageSize = 20,
                query = uiState.searchQuery.ifBlank { null }
            )
                .onSuccess { invitations ->
                    uiState = uiState.copy(
                        isLoading = false,
                        invitations = if (page == 1) invitations else uiState.invitations + invitations,
                        page = page,
                        hasMore = invitations.isNotEmpty()
                    )
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }

    fun onSearchQueryChanged(query: String) {
        uiState = uiState.copy(searchQuery = query)
        loadInvitations(page = 1)
    }
}
